import React from 'react'

import themeStyles from './styles'
import { useTheme } from 'contexts/ThemeProvider'

const Divider = ({ size, customStyle }) => {
  const { theme } = useTheme()
  const styles = themeStyles(theme)
  return (
    <div style={{ ...styles.divider, ...size === 'small' && styles.tinyDivider, ...customStyle }} />
  )
}

export default Divider
